import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment from 'moment';
import * as files from '../../fileUtils';
import { WebCam } from 'vue-web-cam';
import { find, head } from 'lodash';
Vue.component(WebCam.name, WebCam);

//import WebCam from 'vue-web-cam';
//Vue.use(WebCam);

const uiDateFormat = 'DD/MM/YYYY';
const kQualitySamplingPoints = 156;
const cVeryLowVale = 3;
const cVeryHighVale = 4;
const statusPendingEvaluation = "Pending Evaluation";

export default {
  name: 'Samples',
  components: {
    CustomFieldsComp: require('../../components/customFields.vue').default,
    AttachmentsComp: require('../../components/attachments.vue').default,
    LineComp: require('../../components/charts/line.vue').default,
    BarComp: require('../../components/charts/bar.vue').default,
    WebCam
  },
  data: function () {
    return {
      apps: [],
      message: '',
      showFilters: true,
      search: '',
      searchAnalyses: '',
      loggedInUser: '',
      editableStatus: statusPendingEvaluation,
      locations: [],
      laboratories: [],
      sampleTypes: [],
      sampleAnalysisBy: [],
      selectedAnalysisId: -1,
      selectedAnalysis: '',
      standardAnalyses: [],
      samplingReasons: [],
      sampleProjects: [],
      observations: [],
      comparers: [],
      procStatus: [],
      samplingPointTypes: [],
      samplingPointSubtypes: [],
      samplingPointSubtypesFiltered: [],
      projects: [],
      element: '',
      elements: [],
      elementId: -1,
      procStatusId: 5,
      samplingPointTypesId: 0,
      samplingPointSubtypesId: 0,
      projectsId: 0,
      monitoringProgramId: 0,
      monitoringPrograms: [],
      sampleOptions: { pageSize: 10, total: 0, page: 1, filterText: this.search },
      valuesOptions: { pageSize: 10, total: 0, page: 1 },
      analysesOptions: { pageSize: 5, total: 0, page: 1 },
      monitoringProgramOptions: { pageSize: 500, total: 0, page: 1 },
      monitoringProgramElementOptions: { pageSize: 500, total: 0, page: 1 },
      bGPSFiltering: false,
      bHasSubsamples: false,
      bUseMonitoringPrograms: false,
      bShowConfirm: false,
      bShowBlurConfirm: false,
      bParametersVisibility: true,
      customFields: { items: [] },
      sampleId: -1,
      samplesDetail: {
        analysisById: -1,
        analysisDate: null,
        collectionDate: null,
        collectorEmployeeId: -1,
        collectorEmployee: '',
        collector: '',
        creationDateTime: null,
        creationEmployee: '',
        disinfectantResidual: 0,
        evaluationDateTime: null,
        evaluationEmployee: '',
        floatingDebris: '',
        id: -1,
        laboratoryId: -1,
        locationId: -1,
        nuisanceOrganisms: '',
        observationId: -1,
        observations: '',
        preservationIce: false,
        preservationTemp: 0,
        projectId: -1,
        reasonId: -1,
        ref: -1,
        remarks: '',
        samplingPoint: '',
        standardAnalysisId: -1,
        transportComment: '',
        iForcedFieldId: -1,
        typeId: -1,
        versionId: -1,
        waterColor: '',
        waterSurface: '',
        weather: ''
      },
      samplesValues: [],
      attachments: {
        files: [],
        permissions: { add: true, delete: true, download: true, },
        sort: true,
        download: this.download,
        mimeTypes: 'image/png,image/jpeg,application/pdf,application/msword,application/excel',
        multiple: false,
        maxFilesNumber: 3,
        cntrlItemsHelp: []
      },
      samplesData: [],
      disabledDates: date => {
        return (this.samplesDetail && this.samplesDetail.isEditable) ? !this.samplesDetail.isEditable : false;
      },
      showEditSample: false,
      showImage: false,
      showCreateNew: false,
      bShowGraph: false,
      bBatchUpdate: false,
      bDisableButton: false,
      iGraphKey: 0,
      img: null,
      camera: null,
      deviceId: null,
      sActiveTab: 'tab0',
      iActiveTabIndex: -1,
      iValueEditIndex: -1,
      devices: [],
      active: 'first',
      first: false,
      second: false,
      periodBeginDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      periodEndDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
      periodBeginDateTemp: null,
      periodEndDateTemp: null,
      geoLocation: null,
      totalRowSample: 0,
      valuesPageSet: {
        totalRow: 0,//required option
        language: 'en', //this.$i18n.locale, //'el',//default: 'cn'
        pageSizeMenu: [10, 25, 50]//default: [10, 20, 50, 100]
      },
      totalRowAnalyses: 0,
      monitoringProgramPageSet: {
        totalRow: 0,//required option
        language: 'en', //this.$i18n.locale, //'el',//default: 'cn'
        pageSizeMenu: [5, 10, 25]//default: [10, 20, 50, 100]
      },
      monitoringProgramElementPageSet: {
        totalRow: 0,//required option
        language: 'en', //this.$i18n.locale, //'el',//default: 'cn'
        pageSizeMenu: [5, 10, 25]//default: [10, 20, 50, 100]
      },
      chartDataLine: {
        labels: ['January', 'February'],
        datasets: [
          {
            label: 'GitHub Commits',
            borderColor: '#f87979',
            borderWidth: 3,
            pointBorderColor: '#ff0000',
            pointBorderWidth: 2,
            pointRadius: 6,
            pointHoverRadius: 6,
            data: [40, 20],
            fill: false,
          }
        ]
      },
      chartDataBar: {
        labels: ['January', 'February'],
        datasets: [
          {
            label: 'GitHub Commits',
            backgroundColor: '#ffE0E6',
            borderColor: '#ff0000',
            borderWidth: 1,
            data: [40, 20]
          }
        ]
      },
      chartOptions: {
        responsive: false,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Chart.js Line Chart'
        },
        elements: {
          line: {
            tension: 0, // disables bezier curves
          },
          animation: {
            duration: 3000, // general animation time
          },
        }
      },

      dateRange: 6,
      dateRanges: [
        { id: 0, name: this.$t('BOC.CustomRange') },
        { id: 1, name: this.$t('BOC.CurrentDay') },
        { id: 2, name: this.$t('BOC.Last5Days') },
        { id: 3, name: this.$t('BOC.Last10Days') },
        { id: 4, name: this.$t('BOC.Last20Days') },
        { id: 5, name: this.$t('BOC.Last30Days') },
        { id: 6, name: this.$t('BOC.CurrentMonth') },
        { id: 7, name: this.$t('BOC.PreviousMonth') },
        { id: 8, name: this.$t('BOC.Last2Months') },
        { id: 9, name: this.$t('BOC.Last3Months') },
        { id: 10, name: this.$t('BOC.Last6Months') },
        { id: 11, name: this.$t('BOC.Last12Months') }
      ],
      batchFields: [],
      batchFieldValues: [],
      iBatchFieldId: -1,
      iBatchFieldComparerId: -1,
      dBatchFieldValue: 0,
    }
  },
  computed: {
    languageLocale: function () {
      return this.$i18n.locale;
    },
    selectedLength: function () {
      var iCount = 0;
      this.samplesData.forEach(item => (item.isSelected === true) ? iCount++ : 0);
      return iCount;
    },
    device: function () {
      return find(this.devices, n => n.deviceId == this.deviceId);
    },
    sampleDetailId: function () {
      return this.samplesDetail.id;
    }
  },
  watch: {
    languageLocale: function (value) {
      this.dateRanges = [
        { id: 0, name: this.$t('BOC.CustomRange') },
        { id: 1, name: this.$t('BOC.CurrentDay') },
        { id: 2, name: this.$t('BOC.Last5Days') },
        { id: 3, name: this.$t('BOC.Last10Days') },
        { id: 4, name: this.$t('BOC.Last20Days') },
        { id: 5, name: this.$t('BOC.Last30Days') },
        { id: 6, name: this.$t('BOC.CurrentMonth') },
        { id: 7, name: this.$t('BOC.PreviousMonth') },
        { id: 8, name: this.$t('BOC.Last2Months') },
        { id: 9, name: this.$t('BOC.Last3Months') },
        { id: 10, name: this.$t('BOC.Last6Months') },
        { id: 11, name: this.$t('BOC.Last12Months') }
      ];
    },
    bGPSFiltering: function (val) {
      if ((this.bUseMonitoringPrograms === true) && (this.monitoringProgramId > 0))
        this.getMonitoringProgramElements();
      else
        this.getElements();
    },
    monitoringProgramId: function (value) {
      if (this.monitoringProgramId > 0)
        this.getMonitoringProgramElements();
      else
        this.getElements();
      if (this.showCreateNew === true)
        this.getMonitoringProgramStandardAnalysis();
    },
    iBatchFieldId: function (value) {
      if (value > 0) {
        this.getBatchFieldValues();
      }
    },
    selectedLength: function (value) {
      if (value > 0)
        this.getBatchFields();
      else
        this.batchFields = [];
      if (this.iBatchFieldId > 0) {
        this.getBatchFieldValues();
      }
    },
    bBatchUpdate: function () {

      var parameter = {
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: new Date(this.periodEndDate.getFullYear(), this.periodEndDate.getMonth(), this.periodEndDate.getDate() + 1),
        ListOptions: (this.bBatchUpdate === true) ? { pageSize: 1000, total: 0, page: 1, filterText: this.search } : this.sampleOptions,
        SamplingPointId: this.elementId,
        ProjectId: this.projectsId,

        SamplingPointParameters: {
          IdFilterText: null,
          SamplingPointTypeId: this.samplingPointTypesId,
          SamplingPointSubtypeId: this.samplingPointSubtypesId
        },
        ProcessingStatusId: this.procStatusId
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);
      parameter.ListOptions.filterText = this.search;

      this.getSamples(parameter);
    },
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      let firsty = head(this.devices);
      if (firsty) {
        this.camera = firsty.deviceId;
        this.deviceId = firsty.deviceId;
      }
    },
    element: function (value) {
      if (!value) {
        this.elementId = -1;
        this.getElements();
        return;
      }
      
      this.elementId = value.id;
      this.$refs.selectElement.open = false;

      if (this.samplingPointTypesId === -1 || this.samplingPointSubtypesId === -1 || this.elementId === -1)
        return;

      var parameter = {
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: new Date(this.periodEndDate.getFullYear(), this.periodEndDate.getMonth(), this.periodEndDate.getDate() + 1),
        ListOptions: this.sampleOptions,
        SamplingPointId: this.elementId,
        ProjectId: this.projectsId,

        SamplingPointParameters: {
          IdFilterText: null,
          SamplingPointTypeId: this.samplingPointTypesId,
          SamplingPointSubtypeId: this.samplingPointSubtypesId
        },
        ProcessingStatusId: this.procStatusId
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);
      parameter.ListOptions.filterText = this.search;

      this.getSamples(parameter);

      //if (this.bUseMonitoringPrograms === true)
      //  this.getMonitoringPrograms();
    },
    samplingPointTypesId: function (value) {
      if (value === -1)
        return;
      this.samplingPointSubtypesFiltered = this.samplingPointSubtypes.filter(t => t.parentId == value);
      this.samplingPointSubtypesId = 0;
      this.getElements();
    },
    samplingPointSubtypesId: function (value) {
      if (value === -1)
        return;
      this.getElements();
    },
    procStatusId: function (value) {
      if (this.samplingPointTypesId === -1 || this.samplingPointSubtypesId === -1 || this.elementId === -1)
        return;

      var parameter = {
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: new Date(this.periodEndDate.getFullYear(), this.periodEndDate.getMonth(), this.periodEndDate.getDate() + 1),
        ListOptions: this.sampleOptions,
        SamplingPointId: this.elementId,
        ProjectId: this.projectsId,

        SamplingPointParameters: {
          IdFilterText: null,
          SamplingPointTypeId: this.samplingPointTypesId,
          SamplingPointSubtypeId: this.samplingPointSubtypesId
        },
        ProcessingStatusId: this.procStatusId
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);
      parameter.ListOptions.filterText = this.search;

      this.getSamples(parameter);
    },
    projectsId: function (value) {
      if (this.samplingPointTypesId === -1 || this.samplingPointSubtypesId === -1 || this.elementId === -1)
        return;

      var parameter = {
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: new Date(this.periodEndDate.getFullYear(), this.periodEndDate.getMonth(), this.periodEndDate.getDate() + 1),
        ListOptions: this.sampleOptions,
        SamplingPointId: this.elementId,
        ProjectId: this.projectsId,

        SamplingPointParameters: {
          IdFilterText: null,
          SamplingPointTypeId: this.samplingPointTypesId,
          SamplingPointSubtypeId: this.samplingPointSubtypesId
        },
        ProcessingStatusId: this.procStatusId
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);
      parameter.ListOptions.filterText = this.search;

      this.getSamples(parameter);
    },
    periodBeginDate: function (value) {
      if (this.dateRange === 0) {
        this.setDateRanges(0);
      }
    },
    periodEndDate: function (value) {
      if (this.dateRange === 0) {
        this.setDateRanges(0);
      }
    },
    dateRange: function (value) {
      if (value === 0)
        return;
      this.setDateRanges(value);
    },
  },
  created() {
    this.loggedInUser = this.$localStorage.get('_login');
    var geoOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    var geo = navigator.geolocation.getCurrentPosition(
      (pos) => { this.geoLocation = pos; },
      (err) => { this.$alertMsg(err.message); },
      geoOptions
    );
    this.getProfileHydrology();
    this.getElements();
  },
  methods: {
    datePickerBeginOpened() {
      this.periodBeginDateTemp = this.periodBeginDate;
    },
    datePickerBeginClosed() {
      setTimeout(() => {
        if (this.periodBeginDateTemp !== this.periodBeginDate)
          this.dateRange = 0;
      }, 500);
    },
    datePickerEndOpened() {
      this.periodEndDateTemp = this.periodEndDate;
    },
    datePickerEndClosed() {
      setTimeout(() => {
        if (this.periodEndDateTemp !== this.periodEndDate)
          this.dateRange = 0;
      }, 500);
    },
    searchLogs() {
      var parameter = {
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: new Date(this.periodEndDate.getFullYear(), this.periodEndDate.getMonth(), this.periodEndDate.getDate() + 1),
        ListOptions: this.sampleOptions,
        SamplingPointId: this.elementId,
        ProjectId: this.projectsId,

        SamplingPointParameters: {
          IdFilterText: null,
          SamplingPointTypeId: this.samplingPointTypesId,
          SamplingPointSubtypeId: this.samplingPointSubtypesId
        },
        ProcessingStatusId: this.procStatusId
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);
      parameter.ListOptions.filterText = this.search;

      this.getSamples(parameter);
    },
    getStatistics(value) {
      var sAvg = value.averageValue !== null ? 'avg: ' + parseFloat(value.averageValue).toFixed(2) : '';
      var sMax = value.maxValue !== null ? 'max: ' + parseFloat(value.maxValue).toFixed(2) : '';
      var sMin = value.minValue !== null ? 'min: ' + parseFloat(value.minValue).toFixed(2) : '';

      return sAvg + (sMax.length > 0 ? ', ' + sMax : '') + (sMin.length > 0 ? ', ' + sMin: '');
    },
    getTabIcon() {
      return this.bHasSubsamples === true ? 'format_color_fill' : 'note_add';
    },
    getTabLabel() {
      return this.bHasSubsamples === true ? this.$t('samples.Subsamples') : this.$t('samples.Values');
    },
    formatDateUI(date) {
      return moment(date).format(uiDateFormat);
    },
    setBatchFieldValues() {
      if (this.iBatchFieldId <= 0)
        return;

      var sampleIds = [];
      
      this.batchFieldValues.forEach((item) => {
        var sample4Update = {
          SampleId: item.sampleId,
          VersionId: item.versionId,
          Comparer: this.iBatchFieldComparerId,
          Value: this.dBatchFieldValue
        };
        sampleIds.push(sample4Update);
      });

      var parameter = {
        Values: sampleIds,
        FieldId: this.iBatchFieldId
      };

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/SetBatchFieldValues', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.BatchUpdateSavedSuccess'), 2);
          }
          else
            this.$alertMsg(response.data.data.text, 4);
          loader.hide();
        })
        .catch(e => { loader.hide(); this.$router.push('/login'); return false; })
    },
    getBatchFieldValues() {
      if (this.iBatchFieldId <= 0)
        return;

      var sampleIds = [];
      this.samplesData.forEach(item => (item.isSelected === true) ? sampleIds.push(item.sampleId) : 0);
      var parameter = {
        SampleIds: sampleIds,
        FieldId: this.iBatchFieldId
      };

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/GetBatchFieldValues', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.batchFieldValues = response.data.items;
            if (this.comparers.length === 0)
              this.getComparersLookup();
          }
          else
            this.$alertMsg(response.data.data.text);
          loader.hide();
        })
        .catch(e => { loader.hide(); this.$router.push('/login'); return false; })
    },
    getBatchFields() {

      var sampleIds = [];
      this.samplesData.forEach(item => (item.isSelected === true) ? sampleIds.push(item.sampleId) : 0);
      var parameter = {
        SampleIds: sampleIds
      };

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/GetBatchFields', parameter)
        .then(response => {
          if (response.data.data.status == 0)
            this.batchFields = response.data.items;
          else
            this.$alertMsg(response.data.data.text, 4);
          loader.hide();
        })
        .catch(e => { loader.hide(); this.$router.push('/login'); return false; })
    },
    selectAll() {
      if (this.selectedLength === this.samplesData.length) {
        this.samplesData.forEach(item => item.isSelected = false);
      } else {
        this.samplesData.forEach(item => item.isSelected = true);
      }
    },
    getInputClass(iFieldId) {
      return (this.iForcedFieldId === iFieldId) ? 'md-invalid' : ''
    },
    onBlur(event) {
      if (this.bShowBlurConfirm === true)
        return;

      if ((event.maxValue !== null && event.maxValue < event.value) || (event.minValue !== null && event.minValue > event.value)) {
        this.iForcedFieldId = event.fieldId;
        this.sForcedLabel = event.name;
        this.bShowBlurConfirm = true;
      }
    },
    getForcedContent() {
      return this.$t('logs.DescribeForced1') + this.sForcedLabel + this.$t('logs.DescribeForced2');
    },
    confirmForcedYes() {
      var item = this.samplesValues.filter(p => p.fieldId === this.iForcedFieldId)[0];

      if (item)
        item.isForcedValue = true

      this.iForcedFieldId = -1;
      this.bShowBlurConfirm = false;
    },
    confirmForcedNo() {
      var item = this.samplesValues.filter(p => p.fieldId === this.iForcedFieldId)[0];

      if (item)
        item.isForcedValue = false

      if (item.maxValue < item.value)
        item.value = item.maxValue;

      if (item.minValue > item.value)
        item.value = item.minValue;

      this.iForcedFieldId = -1;
      this.bShowBlurConfirm = false;
    },
    dateCompare(a, b) {
      return new Date(a.sampleDate).getTime() - new Date(b.sampleDate).getTime();
    },
    showChart(header) {

      if (this.bShowGraph === true && this.iGraphKey === header.fieldId) {
        this.bShowGraph = false;
        return;
      }

      this.iGraphKey = header.fieldId;

      var xValues = ['x'];
      var yValues = ['Sample Parameter Value'];

      var histValues = header.historyValues.sort(this.dateCompare);

      //histValues.sort(function (a, b) {
      //  return new Date(a.result.date) - new Date(a.result.date);
      //});

      histValues.forEach((item) => {
        xValues.push(moment(item.sampleDate).format(uiDateFormat));
        yValues.push(item.value);
      });

      this.chartDataLine.labels = xValues.slice(1);
      this.chartDataLine.datasets[0].label = ''; //'avg: ' + header.averageValue + ', max: ' + header.maxValue + ', min: ' + header.minValue;
      this.chartDataLine.datasets[0].data = yValues.slice(1);

      this.chartDataBar.labels = xValues.slice(1);
      this.chartDataBar.datasets[0].label = ''; //'avg: ' + header.averageValue + ', max: ' + header.maxValue + ', min: ' + header.minValue;
      this.chartDataBar.datasets[0].data = yValues.slice(1);

      this.chartOptions.display = true;
      this.chartOptions.title.text = header.name + ', avg: ' + header.averageValue + ', max: ' + header.maxValue + ', min: ' + header.minValue;

      this.bShowGraph = true;
    },
    getComparerText(iKey) {
      return (this.comparers.filter(t => t.id == iKey).length > 0) ? this.comparers.filter(t => t.id == iKey)[0].name : '';
    },
    onCapture() {
      this.img = this.$refs.webcam.capture();
      this.$forceUpdate();
      this.showImage = true;
    },
    onStarted(stream) {
      //console.log('On Started Event', stream);
    },
    onStopped(stream) {
      //console.log('On Stopped Event', stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error, stream) {
      console.log('On Error Event', error, stream);
    },
    onCameras(cameras) {
      this.devices = cameras;
      //console.log('On Cameras Event', cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId
      //console.log('On Camera Change Event', deviceId);
    },
    getComparer(iKey) {
      return (this.comparers.filter(t => t.id == iKey).length > 0) ? this.comparers.filter(t => t.id == iKey)[0].name : '';
    },
    getElements() {
      if (this.samplingPointTypesId === -1 || this.samplingPointSubtypesId === -1)
        return;

      var parameter = {
        ElementTypeId: kQualitySamplingPoints,
        FilterByCurrentLocation: false,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0,
        ListOptions: { pageSize: 500, total: 0, page: 1, filterText: this.search },
        SamplingPointParameters: {
          IdFilterText: '',
          SamplingPointTypeId: this.samplingPointTypesId,
          SamplingPointSubtypeId: this.samplingPointSubtypesId
        },
      };
      if (this.geoLocation != null) {
        parameter.FilterByCurrentLocation = this.bGPSFiltering;
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }
      axios.post('/Element/GetElements', parameter)
        .then(response => {
          if (response.status == 200) {
            this.elements = response.data.items;
            //this.$refs.selectElement.open = true;
          }
          else {
            this.$alertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          console.log("err", e);
         this.$alertMsg(e, 4);
          //this.$router.push('/login');
          return false;
        })
    },
    getElementsAux(parameter) {
      if (this.samplingPointTypesId === -1 || this.samplingPointSubtypesId === -1)
        return;

      axios.post('/Element/GetElements', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.elements = response.data.items;
            this.$refs.selectElement.open = true;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getLookups() {
      axios.post('/Sample/GetLookups')
        .then(response => {
          if (response.data.data.status == 0) {
            this.procStatus = response.data.procStatus;
            this.samplingPointTypes = response.data.samplingPointTypes;
            this.samplingPointSubtypes = response.data.samplingPointSubtypes;
            this.samplingPointSubtypesFiltered = this.samplingPointSubtypes;
            this.projects = response.data.projects;
            this.procStatusId = 5;
            this.samplingPointTypesId = 0;
            this.samplingPointSubtypesId = 0;
            this.projectsId = 0;

            if (this.bUseMonitoringPrograms) {
              this.getMonitoringPrograms();
            }
            else
              this.getElements();
          }
          else {
           this.$alertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getComparersLookup() {
      axios.post('/Sample/GetComparersLookup')
        .then(response => {
          if (response.data.data.status == 0) {
            this.comparers = response.data.comparers;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getSamplingPointLookups(parameter) {
      axios.post('/Sample/GetSamplingPointLookups', parameter)
        .then(response => {
          if (response.data.data.status == 0) {

            this.locations = response.data.locations;
            this.laboratories = response.data.laboratories;
            this.sampleTypes = response.data.sampleTypes;
            this.sampleAnalysisBy = response.data.sampleAnalysisBy;
            this.samplingReasons = response.data.samplingReasons;
            this.sampleProjects = response.data.sampleProjects;
            this.observations = response.data.observations;
            this.comparers = response.data.comparers;

            this.getElements();
          }
          else {
           this.$alertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getProfileHydrology() {
      axios.post('/account/GetProfileDetails')
        .then(response => {
          //console.log("response", response)
          if (response.status == 200) {
            var resp = response.data.item;
            this.bUseMonitoringPrograms = (resp.portalHydrology && resp.portalHydrology === true) ? true : false;
            this.getLookups();
          }
        })
        .catch(e => {
          console.log("err", e);
          this.$alertMsg(e);
          //this.$router.push('/login');
        })
    },
    getMonitoringPrograms() {
      var parameter = {
        ElementTypeId: kQualitySamplingPoints, //this.elementId, // All: SamplingPointId = 0
        ListOptions: { pageSize: 500, total: 0, page: 1, filterText: '' },
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Hydrology/GetMonitoringPrograms', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            var monProgAll = {
              category: '',
              dataSource: '',
              employee: 'Edams User',
              frequency: 2,
              name: 'All Programs',
              origin: '',
              preProcessing: '',
              programId: 0,
              remarks: '',
              type: 'Quantity'
            };
            this.monitoringPrograms.push(monProgAll);

            response.data.items.forEach(item => this.monitoringPrograms.push(item));

            this.monitoringProgramOptions.total = response.data.count;
            this.monitoringProgramPageSet.totalRow = response.data.count;
          }
          else {
           this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch(e => { loader.hide(); this.$router.push('/login'); return false; })
    },
    getMonitoringProgramElements() {
      var parameter = {
        ProgramId: this.monitoringProgramId, // All: SamplingPointId = 0
        FilterByCurrentLocation: false,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0,
        ListOptions: { pageSize: 500, total: 0, page: 1, filterText: '' },
      };
      if (this.geoLocation != null) {
        parameter.FilterByCurrentLocation = this.bGPSFiltering;
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }
      axios.post('/Hydrology/GetMonitoringProgramElements', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.elements = response.data.items;

            this.monitoringProgramElementOptions.total = response.data.count;
            this.monitoringProgramElementPageSet.totalRow = response.data.count;
          }
          else {
           this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getMonitoringProgramStandardAnalysis() {
      var parameter = {
        ProgramId: this.monitoringProgramId, // All: SamplingPointId = 0
        ListOptions: { pageSize: 500, total: 0, page: 1, filterText: this.searchAnalyses },
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Hydrology/GetMonitoringProgramStandardAnalyses', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.standardAnalyses = response.data.items;

            this.analysesOptions.total = response.data.count;
            this.totalRowAnalyses = response.data.count;

            this.showCreateNew = true;
          }
          else {
           this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch(e => { loader.hide(); this.$router.push('/login'); return false; })
    },
    getMonitoringProgramStandardAnalysisAux() {
      var parameter = {
        ProgramId: this.monitoringProgramId, // All: SamplingPointId = 0
        ListOptions: { pageSize: 500, total: 0, page: 1, filterText: this.searchAnalyses },
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Hydrology/GetMonitoringProgramStandardAnalyses', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.standardAnalyses = response.data.items;

            this.analysesOptions.total = response.data.count;
            this.totalRowAnalyses = response.data.count;
          }
          else {
           this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch(e => { loader.hide(); this.$router.push('/login'); return false; })
    },
    getSamplingPointStandardAnalyses(parameter) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/GetSamplingPointStandardAnalyses', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.standardAnalyses = response.data.items;

            this.analysesOptions.total = response.data.count;
            this.totalRowAnalyses = response.data.count;

            this.showCreateNew = true;
          }
          else {
           this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch(e => { loader.hide(); this.$router.push('/login'); return false; })
    },
    getSamplingPointStandardAnalysesAux(parameter) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/GetSamplingPointStandardAnalyses', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.standardAnalyses = response.data.items;
          }
          else {
           this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch(e => { loader.hide(); this.$router.push('/login'); return false; })
    },
    getSamples(parameter) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/GetSamples', parameter)
        .then(response => {
          response.data.items.forEach(item => item.isSelected = false);
          this.samplesData = response.data.items;

          this.sampleOptions.total = response.data.count;
          this.totalRowSample = response.data.count;
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getSamplesAux() {
      var parameter = {
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: new Date(this.periodEndDate.getFullYear(), this.periodEndDate.getMonth(), this.periodEndDate.getDate() + 1),
        ListOptions: (this.bBatchUpdate === true) ? { pageSize: 1000, total: 0, page: 1, filterText: this.search } : this.sampleOptions,
        SamplingPointId: this.elementId,
        ProjectId: this.projectsId,

        SamplingPointParameters: {
          IdFilterText: null,
          SamplingPointTypeId: this.samplingPointTypesId,
          SamplingPointSubtypeId: this.samplingPointSubtypesId
        },
        ProcessingStatusId: this.procStatusId
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);
      parameter.ListOptions.filterText = this.search;

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/GetSamples', parameter)
        .then(response => {
          response.data.items.forEach(item => item.isSelected = false);
          this.samplesData = response.data.items;

          this.sampleOptions.total = response.data.count;
          this.totalRowSample = response.data.count;
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getSample(parameter) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/GetSample', parameter)
        .then(response => {
          response.data.item.collector = response.data.item.collectorEmployeeId + ' - ' + response.data.item.collectorEmployee;

          this.samplesDetail = response.data.item;

          this.samplesDetail.creationDateTime = this.formatDateUI(this.samplesDetail.creationDateTime);
          this.samplesDetail.creationDateTime = this.samplesDetail.creationDateTime.indexOf('0001') !== -1 ? '' : this.samplesDetail.creationDateTime;
                    

          for (var i = 0; i < response.data.values.length; ++i) {
            response.data.values[i].numbering = i + 1;
            response.data.values[i].isForcedValue = false;
          }
          
          this.samplesValues = response.data.values;

          this.bHasSubsamples = (this.samplesDetail.subSamples!==null && this.samplesDetail.subSamples.length > 0);

          this.valuesOptions.total = response.data.valuesCount;
          this.valuesPageSet.totalRow = response.data.valuesCount;

          loader.hide();

        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getClass(id) {
      return (id === this.readingBatchId) ? 'selected' : 'samples';
    },
    download(id) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/DownloadAttachment', { Value: id }, { responseType: 'blob' })
        .then(files.getFile)
        .then((link) => {
          link.click();
        })
        .then(response => {
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
          console.log(err)
        })
    },
    getAttachments(sampleId) {
      this.bDisableButton = true;
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/GetAttachments', { Value: sampleId })
        .then(response => {
          if (response.data.data.status == 0) {
            var files = response.data.items;
            this.attachments.files = [];
            for (var i = 0; i < files.length; ++i) {
              var file = files[i];
              this.attachments.files.push({ id: file.id, seqId: 0, deleted: false, name: file.fileName });
            }
          }
          else
            this.closeWithMessage(this.$t('messages.CannotGetAttachmentsFromServer'), 1);
          this.bDisableButton = false;
          loader.hide();
        })
        .catch(e => {
          this.bDisableButton = false;
          loader.hide();
          this.$router.push('/login');
        })
    },
    processAttachments(uploadFiles, deleteFiles) {
      if (this.samplesDetail.id <= 0)
        return;

      var formData = new FormData();
      formData.append("sampleId", this.samplesDetail.id.toString());

      for (var i = 0; i < uploadFiles.length; ++i)
        formData.append("uploadFiles", uploadFiles[i]);

      for (var i = 0; i < deleteFiles.length; ++i)
        formData.append("deleteFiles", deleteFiles[i]);

      this.bDisableButton = true;
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/ProcessAttachments', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.data.data.status == 0) {
           this.$alertMsg(this.$t('messages.AttachmentSavedSuccess'), 2);
            this.getAttachments(this.sampleId);
          }
          else
           this.$alertMsg(response.data.data.text);
          this.bDisableButton = false;
          loader.hide();
        })
        .catch(e => {
          this.bDisableButton = false;
          loader.hide();
          this.$router.push('/login');
          return false;
        });
    },
    saveAttachments() {
      if (this.bDisableButton === true)
        return;

      var newFiles = [];
      var deleteFiles = [];

      this.attachments.files.forEach(function (file) {
        if (file.id < 0) // new
          newFiles.push(file.file);
        else if (file.deleted)
          deleteFiles.push(file.id);
      });

      if (deleteFiles.length > 0 || newFiles.length > 0)
        this.processAttachments(newFiles, deleteFiles);
    },
    getCustomFields(sampleId) {
      var parameter = {
        Value: sampleId
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/GetCustomFields', parameter)
        .then(response => {
          this.customFields.items = response.data.items;
          this.$root.$emit('custom_fields_updated');
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    setDateRanges(iKey) {

      switch (iKey) {
        case 0: //Custom Date
          // do nothing
          break;
        case 1: //Current Day
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          break;
        case 2: //Last 5 Days
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = this.addDays(this.periodEndDate, -5);
          break;
        case 3: //Last 10 Days
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = this.addDays(this.periodEndDate, -10);
          break;
        case 4: //Last 20 Days
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = this.addDays(this.periodEndDate, -20);
          break;
        case 5: //Last 30 Days
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = this.addDays(this.periodEndDate, -30);
          break;
        case 6: //Current Month
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
          break;
        case 7: //Previous Month
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
          this.periodBeginDate = this.addMonths(new Date(new Date().getFullYear(), new Date().getMonth(), 1), -1);
          break;
        case 8: //Last 2 Months
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = this.addMonths(this.periodEndDate, -2);
          break;
        case 9: //Last 3 Months
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = this.addMonths(this.periodEndDate, -3);
          break;
        case 10: //Last 6 Months
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = this.addMonths(this.periodEndDate, -6);
          break;
        case 11: //Last 12 Months
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = this.addMonths(this.periodEndDate, -12);
          break;
        default: //Current Month
          this.periodEndDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
          this.periodBeginDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      }

      //if (iKey === 0)
      //  return;

      var parameter = {
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: new Date(this.periodEndDate.getFullYear(), this.periodEndDate.getMonth(), this.periodEndDate.getDate() + 1),
        ListOptions: this.sampleOptions,
        SamplingPointId: this.elementId,
        ProjectId: this.projectsId,

        SamplingPointParameters: {
          IdFilterText: null,
          SamplingPointTypeId: this.samplingPointTypesId,
          SamplingPointSubtypeId: this.samplingPointSubtypesId
        },
        ProcessingStatusId: this.procStatusId
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);
      parameter.ListOptions.filterText = this.search;

      this.getSamples(parameter);
    },
    samplePageChange(pInfo) {
      //if (this.samplingPointTypesId === -1 || this.samplingPointSubtypesId === -1 || this.elementId === -1)
      //  return;

      var parameter = {
        PeriodBegin: this.periodBeginDate,
        PeriodEnd: new Date(this.periodEndDate.getFullYear(), this.periodEndDate.getMonth(), this.periodEndDate.getDate() + 1),
        ListOptions: {
          PageSize: pInfo.pageSize,
          Page: pInfo.pageNumber,
          FilterText: null
        },
        SamplingPointId: this.elementId,
        ProjectId: this.projectsId,

        SamplingPointParameters: {
          IdFilterText: null,
          SamplingPointTypeId: this.samplingPointTypesId,
          SamplingPointSubtypeId: this.samplingPointSubtypesId
        },
        ProcessingStatusId: this.procStatusId
      };

      parameter.PeriodBegin.setHours(0, 0, 0, 0);
      parameter.PeriodEnd.setHours(0, 0, 0, 0);

      this.getSamples(parameter);
    },
    valuesPageChange(pInfo) {
      var parameter = {
        SampleId: this.sampleId
      };

      this.getSample(parameter);
    },
    analysesPageChange(pInfo) {
      if (this.samplingPointTypesId === -1 || this.samplingPointSubtypesId === -1 || this.elementId === -1)
        return;

      if (this.bUseMonitoringPrograms === true) {
        this.getMonitoringProgramStandardAnalysis();
      }
      else {
        var parameter = {
          SamplingPointId: this.elementId,
          ListOptions: {
            PageSize: pInfo.pageSize,
            Page: pInfo.pageNumber,
            FilterText: this.searchAnalyses
          },
        };
        this.getSamplingPointStandardAnalyses(parameter);
      }
    },
    setActiveTab(iTabKey) {
      this.iActiveTabIndex = iTabKey;
      this.sActiveTab = 'tab' + iTabKey;
    },
    selectSample(value) {
      this.sampleId = value.sampleId;

      var parameter = {
        SampleId: this.sampleId
      };

      this.active = 'second';
      this.first = false;
      this.second = true;

      this.setActiveTab(0);

      this.getSamplingPointLookups(parameter);
      this.getSample(parameter);

      this.getCustomFields(this.sampleId);
      this.getAttachments(this.sampleId);
    },
    savePhoto() {
      this.processPhotos();
      this.showImage = false;
    },
    discardPhoto() {
      this.img = null;
      this.showImage = false;
    },
    processPhotos() {
      if (!this.img)
        return;

      if (this.samplesDetail.id <= 0)
        return;

      var formData = new FormData();
      formData.append("sampleId", this.samplesDetail.id.toString());
      formData.append("photoBase64", this.img)

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });

      return axios.post('/Sample/ProcessPhoto', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
        this.$root.$emit('camera_photos_updated');
        this.getAttachments(this.samplesDetail.id);
        loader.hide();
      })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        });
    },
    saveCustomFields() {
      if (this.samplesDetail.id <= 0)
        return;

        var cFieldsUpd = [];

        this.customFields.items.forEach(item => {
          var cField = {
            CustomFieldId: item.customFieldId,
            StrValue: item.strValue,
            IntValue: item.intValue,
            DblValue: item.dblValue,
            DateValue: item.dateValue,
            DataId: item.dataId
          };
          cFieldsUpd.push(cField);
        });

        let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
        axios.post('/Sample/SaveCustomFieldValues', {
          ApplicationId: this.samplesDetail.id,
          Values: cFieldsUpd
        })
          .then(response => {
            if (response.data.data.status == 0) {
             this.$alertMsg(this.$t('messages.CustomFieldSavedSuccess'), 2);
            }
            else
             this.$alertMsg(response.data.data.text);
            loader.hide();
          })
          .catch((e) => { loader.hide();this.$alertMsg(e.message); })
    },
    saveSample() {
      var saveValues = [];

      this.samplesValues.forEach(item => {
        var saveValue = {
          FieldId: item.fieldId,
          ToBeTested: item.isLabTest,
          Comparer: item.comparer,
          Value: item.value,
          IsForcedValue: item.isForcedValue,
          Remarks: item.remarks
        };
        saveValues.push(saveValue);
      });

      var saveHeader = {
        Id: this.samplesDetail.id,
        SamplingPointId: this.samplesDetail.samplingPointId,
        StandardAnalysisId: this.samplesDetail.standardAnalysisId,

        LocationId: this.samplesDetail.locationId,
        Ref: this.samplesDetail.ref,
        LaboratoryId: this.samplesDetail.laboratoryId,
        TypeId: this.samplesDetail.typeId,
        AnalysisById: this.samplesDetail.analysisById,

        CollectionDate: this.samplesDetail.collectionDate,

        AnalysisDate: this.samplesDetail.analysisDate,
        ReasonId: this.samplesDetail.reasonId,
        ProjectId: this.samplesDetail.projectId,
        Remarks: this.samplesDetail.remarks,
        Depth: this.samplesDetail.depth,

        Weather: this.samplesDetail.weather,
        WaterColor: this.samplesDetail.waterColor,
        WaterSurface: this.samplesDetail.waterSurface,
        NuisanceOrganisms: this.samplesDetail.nuisanceOrganisms,
        FloatingDebris: this.samplesDetail.floatingDebris,
        Odour: this.samplesDetail.odour,
        Observations: this.samplesDetail.observations,
        ObservationId: this.samplesDetail.observationId,

        PreservationIce: this.samplesDetail.preservationIce,
        PreservationTemp: this.samplesDetail.preservationTemp,
        DisinfectantResidual: this.samplesDetail.disinfectantResidual,
        TransportComment: this.samplesDetail.transportComment,

        IsMasterSample: this.samplesDetail.isMasterSample,
        ParentSampleId: this.samplesDetail.parentSampleId,

        VersionId: this.samplesDetail.versionId,

        FieldValues: saveValues
      };

      if (saveHeader.CollectionDate)
        saveHeader.CollectionDate = moment(saveHeader.CollectionDate).format();
      if (saveHeader.AnalysisDate)
        saveHeader.AnalysisDate = moment(saveHeader.AnalysisDate).format();

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/InsertOrUpdateSample', saveHeader)
        .then(response => {
          if (response.data.data.status == 0) {
            this.samplesDetail.versionId = this.samplesDetail.id > 0? this.samplesDetail.versionId + 1: 1;
            this.samplesDetail.id = this.samplesDetail.id === 0 ? response.data.id : this.samplesDetail.id;
            this.saveCustomFields();
            this.saveAttachments();
           this.$alertMsg(this.$t('messages.SampleSavedSuccess'), 2);
          }
          else
           this.$alertMsg(response.data.data.text);

          loader.hide();
        })
        .catch((e) => { loader.hide();this.$alertMsg(e.message); })
    },
    showNew() {
      var parameter = {
        SamplingPointId: this.elementId,
        ListOptions: {
          PageSize: 5,
          Page: 1,
          FilterText: this.searchAnalyses
        },
      };
      if (this.bUseMonitoringPrograms === true)
        this.getMonitoringProgramStandardAnalysis();
      else
        this.getSamplingPointStandardAnalyses(parameter);
    },
    createNew(analysisId) {
      this.showCreateNew = false;
      this.standardAnalyses = [];

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/CreateNewSample', {
        SamplingPointId: this.elementId,
        StandardAnalysisId: analysisId
      })
        .then(response => {
          if (response.data.data.status == 0) {
           this.$alertMsg(this.$t('messages.SampleCreatedSuccess'), 2);

            this.samplesDetail = response.data.item;
            this.samplesDetail.creationDateTime = this.formatDateUI(this.samplesDetail.creationDateTime);
            this.samplesDetail.creationDateTime = this.samplesDetail.creationDateTime.indexOf('0001') !== -1 ? '' : this.samplesDetail.creationDateTime;
            this.samplesDetail.analysisDate = new Date();

            for (var i = 0; i < response.data.values.length; ++i) {
              response.data.values[i].numbering = i + 1;
              response.data.values[i].isForcedValue = false;
            }

            this.samplesValues = response.data.values;

            this.sampleId = this.samplesDetail.sampleId;

            var parameter = {
              SampleId: this.sampleId
            };

            this.getSamplingPointLookups(parameter);

            this.getCustomFields(this.sampleId);
            this.getAttachments(this.sampleId);

            this.active = 'second';
            this.first = false;
            this.second = true;
            if (this.iActiveTabIndex === -1)
              this.iActiveTabIndex = 0;

            loader.hide();
          }
        })
        .catch((e) => { loader.hide();this.$alertMsg(e.message); })
    },
    deleteSample() {
      if (this.samplesDetail.id <= 0)
        return;

      this.bShowConfirm = true;
    },
    confirmDeleteYes() {
      this.bShowConfirm = false;

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/Sample/DeleteSample', {
        Value: this.samplesDetail.id
      })
        .then(response => {
          if (response.data.data.status == 0) {
           this.$alertMsg(this.$t('messages.SampleDeletedSuccess'), 2);

            this.iActiveTabIndex = -1;

            this.active = 'first';
            this.first = true;
            this.second = false;

            var parameter = {
              PeriodBegin: this.periodBeginDate,
              PeriodEnd: new Date(this.periodEndDate.getFullYear(), this.periodEndDate.getMonth(), this.periodEndDate.getDate() + 1),
              ListOptions: this.sampleOptions,
              SamplingPointId: this.elementId,
              ProjectId: this.projectsId,

              SamplingPointParameters: {
                IdFilterText: null,
                SamplingPointTypeId: this.samplingPointTypesId,
                SamplingPointSubtypeId: this.samplingPointSubtypesId
              },
              ProcessingStatusId: this.procStatusId
            };

            parameter.PeriodBegin.setHours(0, 0, 0, 0);
            parameter.PeriodEnd.setHours(0, 0, 0, 0);
            parameter.ListOptions.filterText = this.search;

            this.getSamples(parameter);
            
            loader.hide();
          }
        })
        .catch((e) => { loader.hide();this.$alertMsg(e.message); })
    },
    confirmDeleteNo() {
      this.bShowConfirm = false;
    },
    addDays(date, days) {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + days);
    },
    addMonthsUTC(date, count) {
      if (date && count) {
        var m, d = (date = new Date(+date)).getUTCDate()

        date.setUTCMonth(date.getUTCMonth() + count, 1)
        m = date.getUTCMonth()
        date.setUTCDate(d)
        if (date.getUTCMonth() !== m) date.setUTCDate(0)
      }
      return date
    },
    addMonths(date, count) {
      if (date && count) {
        var m, d = (date = new Date(+date)).getDate()

        date.setMonth(date.getMonth() + count, 1)
        m = date.getMonth()
        date.setDate(d)
        if (date.getMonth() !== m) date.setDate(0)
      }
      return date
    },
    closeDialog() {
      this.showEditSample = false;
    },
    onElementSearch(val) {

      if (val.length < 3)
        return;

      var parameter = {
        ElementTypeId: kQualitySamplingPoints,
        FilterByCurrentLocation: false,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0,
        ListOptions: { pageSize: 500, total: 0, page: 1, filterText: val },
        SamplingPointParameters: {
          IdFilterText: '',
          SamplingPointTypeId: this.samplingPointTypesId,
          SamplingPointSubtypeId: this.samplingPointSubtypesId
        },
      };

      if (this.geoLocation != null) {
        parameter.FilterByCurrentLocation = false;
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }
      this.getElementsAux(parameter);
    },
    closeNew() {
      this.showCreateNew = false;
      this.standardAnalyses = [];
    },
    showParameters(bYes) {
      this.bParametersVisibility = bYes;
    },
    gotoSample(id) {
      var route = '/sample/' + id;
      this.$router.push(route);
    },
    formatDateYYYYMMDD(date) {
      return moment(date, 'YYYY-MM-DD'); //.format();
    },
  },
}
